import React, { useState } from "react";
import { Box, Tooltip } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CommonCopy = ({ contentToCopy }) => {
  const [isCopied, setIsCopied] = useState(false);

  // Function to format the content as a table-like structure
  const formatContent = (content) => {
    if (Array.isArray(content)) {
      // If the content is an array, format each object as a table row
      return content.map((item, index) => {
        return Object.entries(item)
          .map(([key, value]) => `${key}: ${value}`)
          .join("\n");
      }).join("\n\n");
    } else if (typeof content === "object" && content !== null) {
      // If the content is an object, format it as "Label: Value" pairs
      return Object.entries(content)
        .map(([key, value]) => `${key}: ${value}`)
        .join("\n");
    } else if (typeof content === "string" || content instanceof String) {
      // If the content is a string, just return it directly
      return content;
    }
    return ''; // If content is neither an object nor a string, return empty
  };

  const handleCopyClick = () => {
    const plainText = formatContent(contentToCopy); // Format as plain text
    navigator.clipboard.writeText(plainText); // Copy to clipboard
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Tooltip title={isCopied ? "Copied!" : "Copy"} arrow>
      <Box
        onClick={handleCopyClick}
        sx={{
          cursor: "pointer",
          "&:hover": {
            color: "#49A3FF", // Change color on hover
          },
        }}
      >
        {isCopied ? (
          <ContentCopyIcon sx={{ fontSize: "24px" }} /> // Filled copy icon when copied
        ) : (
          <ContentCopyOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined copy icon by default
        )}
      </Box>
    </Tooltip>
  );
};

export default CommonCopy;
